<template>
  <div class="cp-results" v-loading="loading">
    <div class="cp-results-header">
      <r-title type="subtitle-2">
        Результаты измерений (Точка {{ activeCpName }})
      </r-title>
      <div class="cp-results-coef-control">
        <r-text @click.native="coefsEnabled = !coefsEnabled" type="caption">
          {{ coefsEnabled ? "С коэффициентами" : "Без коэффициентов" }}
        </r-text>
        <el-switch class="r-switch" v-model="coefsEnabled" />
      </div>
    </div>
    <div class="cp-results-content">
      <div class="cp-results-table-controls">
        <div class="cp-results-dates-controls">
          <div>
            <r-text type="caption" style="margin-bottom: 4px;">
              Дата измерений
            </r-text>
            <div class="cp-results-date-picker">
              <el-date-picker
                class="r-date-picker dark"
                v-model="date"
                value-format="yyyy-MM-dd"
                placeholder="Выберите дату"
                type="date"
                size="mini"
              />
              <el-dropdown
                @command="datePickerHandler"
                class="r-dropdown"
                v-if="dates.length"
              >
                <span class="el-dropdown-link">
                  Существующие <i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu class="r-dropdown-menu" slot="dropdown">
                  <el-dropdown-item
                    class="r-dropdown-menu__item"
                    :command="item"
                    v-for="item in dates"
                    :key="item"
                  >
                    <div class="r-dropdown-menu__item-wrapper">
                      <r-text>{{ item }}</r-text>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div style="margin-left: 32px;">
            <r-text type="caption" style="margin-bottom: 4px;">
              Интервал
            </r-text>
            <el-select
              class="r-select"
              placeholder="Выберите интервал"
              size="mini"
              v-model="interval"
            >
              <el-option
                v-for="item in intervals"
                :key="item.id"
                :value="item.id"
                :label="`${item.start_interval} - ${item.end_interval}`"
              >
                {{ `${item.start_interval} - ${item.end_interval}` }}
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="cp-results-buttons" v-if="changed">
          <el-button
            circle
            type="danger"
            class="r-button icon-button"
            size="mini"
            @click="cancelEditing"
          >
            <r-icon name="trash" type="additional" :size="16" />
          </el-button>
          <el-button
            class="r-button"
            type="primary"
            @click="saveMeasures"
            :loading="saving"
          >
            Сохранить
          </el-button>
        </div>
      </div>
      <div class="cp-results-table">
        <measures-table
          ref="measuresTable"
          v-if="date && interval"
          @changed="changedHandler"
          @saving="savingHandler"
          @update="updateData"
        />
        <div class="cp-results-nodata" v-else>
          <r-text type="caption">
            Выберите дату и интервал для отображения / занесения результатов
          </r-text>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MeasuresTable from "./measures-table";

export default {
  props: ["state", "controller", "id"],
  components: {
    MeasuresTable
  },
  data() {
    return {
      saving: false,
      changed: false
    };
  },
  computed: {
    loading() {
      return this.$store.state.trafficCount.fill.loading;
    },
    activeCpName() {
      return this.$store.state.trafficCount.fill.activeCpName;
    },
    coefsEnabled: {
      get() {
        return this.$store.state.trafficCount.fill.coefsEnabled;
      },
      set(value) {
        this.$store.commit("SET_TC_FILL_PROP", { name: "coefsEnabled", value });
      }
    },
    dates() {
      return this.$store.state.trafficCount.fill.dates;
    },
    date: {
      get() {
        return this.$store.state.trafficCount.fill.date;
      },
      set(value) {
        this.$store.commit("SET_TC_FILL_PROP", { name: "date", value });
      }
    },
    intervals() {
      return this.$store.state.trafficCount.fill.intervals;
    },
    interval: {
      get() {
        return this.$store.state.trafficCount.fill.interval;
      },
      set(value) {
        this.$store.commit("SET_TC_FILL_PROP", { name: "interval", value });
      }
    }
  },
  watch: {
    "$store.state.trafficCount.fill.hoveredTurn": function() {
      this.controller.selectTurn();
    },
    date: function() {
      this.updateData();
    },
    interval: function() {
      this.updateData();
    },
    "$store.state.trafficCount.fill.coefsEnabled": function() {
      this.updateData();
    }
  },
  methods: {
    datePickerHandler(date) {
      this.date = date;
    },
    async updateData() {
      this.$set(this.state, "updated", true);
      await this.controller.getMeasuresDates(this.id);
      await this.controller.getMeasuresIntervals(this.id);
      await this.controller.getMeasuresData(this.id);
    },
    changedHandler(value) {
      this.changed = value;
    },
    savingHandler(value) {
      this.saving = value;
    },
    saveMeasures() {
      this.$refs.measuresTable.saveMeasures();
    },
    cancelEditing() {
      this.$refs.measuresTable.cancelEditing();
    }
  }
};
</script>

<style lang="scss">
.cp-results {
  padding: 16px;

  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
  }

  &-content {
    margin-left: 10px;
  }

  &-coef-control {
    display: flex;
    align-items: center;

    .r-text.caption-2 {
      cursor: pointer;
    }

    .r-switch {
      margin-left: 8px;
    }
  }

  &-table-controls {
    display: flex;
    align-items: flex-end;
  }

  &-dates-controls {
    display: flex;
    align-items: center;

    .el-date-editor.el-input,
    .el-input,
    .el-input__inner {
      width: 160px;
    }

    .el-dropdown-link {
      color: var(--accent_primary);
      font-size: 11px;
      margin-left: 8px;
      cursor: pointer;
    }
  }

  &-date-picker {
    display: flex;
    align-items: center;
  }

  &-buttons {
    margin-left: auto;
    display: flex;
    align-items: center;
    font-size: 0;

    .el-button {
      padding-top: 7px;
      padding-bottom: 7px;
    }
  }

  &-table {
    margin-top: 16px;
  }

  &-nodata {
    text-align: center;
    padding: 16px;
  }
}
</style>
